/** @format */

import { toast } from "react-toastify";
type Variants = "success" | "error" | "info";

export const notify = (variant: Variants, message: string, duration = 5000) => {
	toast[variant](message, {
		autoClose: duration,
		role: variant === "error" ? "alert" : "status",
	});
};
